import { useLinkTo } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useAtomValue, useSetAtom } from "jotai";
import React from "react";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  NoNav_atom,
  navigationRef_atom,
} from "../../features/Navigation/atoms";
import { BaseNavigatorParamList } from "../../navigators/BaseNavigator/types";

type NoNavScreenProps = NativeStackScreenProps<BaseNavigatorParamList, "NoNav">;

export const NoNavScreen = ({ route }: NoNavScreenProps) => {
  const navigationRef = useAtomValue(navigationRef_atom);
  const setNoNav = useSetAtom(NoNav_atom);
  const linkTo = useLinkTo();

  if (navigationRef?.isReady()) {
    setTimeout(() => {
      const newPath = route.path?.replace("/nonav", "");

      linkTo(newPath || "/patron");
      setNoNav(true);
    }, 0);
  }

  return <Loader />;
};
